import React from 'react';

export default function Popup() {
  return (
    <p className="text-xs font-semibold text-center bg-gray-800 text-gray-50 rounded-full p-3 fixed bottom-10">
      Link copied to clipboard!
    </p>
  )
}
